import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-corsi',
  templateUrl: './corsi.component.html',
  styleUrls: ['./corsi.component.scss'],
})
export class CorsiComponent implements OnInit {
  filteredList: any = [];
  activeFilter: string = 'T';
  coursesList: any = [
    {
      name: 'Scratch',
      tag: 'T/E/M',
      img: 'assets/img/corsi/scratch.png',
      text: 'Crea cartoni animati, animazioni e storie interattive, quiz e puzzle, ma anche dei semplici giochi arcade.',
      url: '/scratch',
    },
    {
      name: 'Minecraft',
      tag: 'T/E/M',
      img: 'assets/img/corsi/minecraft.png',
      text: 'Un mondo virtuale da costruire con blocchi tridimensionali e nel quale ci si può muovere liberamente.',
      url: '/minecraft',
    },
    {
      name: 'HTML e CSS',
      tag: 'T/S',
      img: 'assets/img/corsi/html.png',
      text: 'Cosa sono e come sono fatte le pagine web? Creazione di un sito composto da alcune pagine web.',
      url: '/html-css',
    },
    {
      name: 'Educazione ai Social Media',
      tag: 'T/M/S',
      img: 'assets/img/corsi/socialMedia.png',
      text: 'Utilizzo dei social e della comunicazione digitale, esaltandone i lati positivi e le conseguenze di un uso inconsapevole.',
      url: '/social-media',
    },
    {
      name: 'Programmazione Unplugged',
      tag: 'T/E/M',
      img: 'assets/img/corsi/unplugged.png',
      text: 'Un percorso di apprendimento dei principi della programmazione senza l’utilizzo del computer.',
      url: '/unplugged',
    },
    {
      name: 'App Inventor',
      tag: 'T/E/M',
      img: 'assets/img/corsi/appInventor.png',
      text: 'E’ uno strumento per realizzare applicazioni Android. La sua interfaccia consente di programmare senza scrivere codice.',
      url: '/app-inventor',
    },
    {
      name: 'Robotica Educativa',
      tag: 'T/E/M',
      img: 'assets/img/corsi/robotica.png',
      text: 'Per imparare tramite la programmazione e lo sviluppo di un robot, le materie scientifiche alla base della programmazione.',
      url: '/robotica-educativa',
    },
    {
      name: 'Digital Storytelling',
      tag: 'T/E/M',
      img: 'assets/img/corsi/storytelling.png',
      text: 'Creare storie e raccontarle tramite l’uso di tecnologie digitali con benefici didattici, cognitivi, relazionali e motivazionali.',
      url: '/digital-storytelling',
    },
    {
      name: 'UX/UI Design',
      tag: 'T/S',
      img: 'assets/img/corsi/design.png',
      text: 'Imparare la grafica web, il metodo del design, la User Experience (UX) e la User Interface (UI).',
      url: '/ux-ui',
    },
    {
      name: 'Arduino',
      tag: 'T/M/S',
      img: 'assets/img/corsi/arduino.png',
      text: 'Crea il tuo circuito, programmalo e testalo grazie al software di simulazione di Tinkercad Circuits.',
      url: '/arduino',
    },
    {
      name: 'Stampa 3D',
      tag: 'T/M/S',
      img: 'assets/img/corsi/stampa3d.png',
      text: 'Divertiti a dare una forma concreta alle tue idee con il software TinkerCAD.',
      url: '/stampa-3d',
    },
    {
      name: 'Programmazione Droni',
      tag: 'T/M/S',
      img: 'assets/img/corsi/programmazione-droni.png',
      text: 'Impara a programmare il tuo drone Tello EDU, piccolo e compatto ma con molte funzionalità.',
      url: '/programmazione-droni',
    },
  ];

  constructor(private router: Router) {}

  ngOnInit(): void {
    window.scrollTo(0, 0);

    this.filteredList = this.coursesList;
  }

  filter(tag: string) {
    this.activeFilter = tag;
    this.filteredList = this.coursesList.filter(
      (x: { tag: string | string[] }) => x.tag.includes(tag)
    );
  }

  filterName(event: any) {
    let searchString = event.target.value;
    this.filteredList = this.coursesList.filter((x: any) =>
      x.name.toLowerCase().includes(searchString.toLowerCase())
    );
  }

  openCourse(course: any) {
    this.router.navigateByUrl('/corsi' + course.url);
  }
}
